const hostname = typeof window !== 'undefined' ? window.location?.hostname : '';
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (isLocalhost
  ? 'http://localhost:3060'
  : 'https://api.cipex.com.br');

export { API_BASE_URL };
 
